import React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

const DashborHomeToaster = ({ message, pathName }: any) => {
  const [open, setOpen] = React.useState(true);
  return (
    <Box sx={{ width: '100%' }}>
      <Collapse in={open}>
        <Alert
          severity='warning'
          action={
            <IconButton
              aria-label='close'
              color='warning'
              size='small'
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          <Link to={`/${pathName}`}>{message}</Link>
        </Alert>
      </Collapse>
    </Box>
  );
};

export default DashborHomeToaster;
